import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './index.css';

import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Contactus from './pages/contact-us';
import TermsLayout from './pages/termsandconditions';
import PrivacyPolicy from './pages/Privacypolicy';
import DownloadRedirect from './pages/download';
import Faq from './pages/faq';
import SafetyTips from './pages/SafetyTips';
import CommunityGuidelines from './pages/CommunityGuidelines';
import TripSuggestions from './pages/TripSuggestions';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import WriteBlog from './pages/WriteBlog';
import BlogDashboard from './pages/BlogDashboard';
import MyBlogs from './pages/MyBlogs';
import CreateBlog from './pages/CreateBlog';
import Drafts from './pages/Drafts';
import EditDraft from './pages/EditDraft';
import WriterGuidelines from './pages/WriterGuidelines';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 500,
      once: true,
    });
  }, []);

  return (
    <Router>
      <div className="App">
        {/* Routing Logic */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/terms-and-conditions" element={<TermsLayout />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
          <Route path="/faq" element={<Faq/>} />
          <Route path="/download" element={<DownloadRedirect />} />
          <Route path="/safety-tips" element={<SafetyTips />} />
          <Route path="/community-guidelines" element={<CommunityGuidelines />} />
          <Route path="/trip-suggestions" element={<TripSuggestions />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/write-blog" element={<WriteBlog />} />
          <Route path="/dashboard" element={<BlogDashboard />} />
          <Route path="/dashboard/my-blogs" element={<MyBlogs />} />
          <Route path="/dashboard/create-blog" element={<CreateBlog />} />
          <Route path="/dashboard/drafts" element={<Drafts />} />
          <Route path="/dashboard/edit-draft" element={<EditDraft />} />
          <Route path="/dashboard/writer-guidelines" element={<WriterGuidelines />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
